import { useCallback, memo } from "react";
import { useField } from "formik";

import { PRINT_TYPE } from "@/features/campaigns/direct-mail/rrd/utils/rrdConstants";
import { MUICustomAutocompleteSelect } from "@/components/muiCustom/select/MUICustomAutocompleteSelect";

type RRDDirectPrintTypeInputProps = {
  name?: string;
  wrapperProps?: Record<string, any>;
};

function RRDDirectPrintTypeInput({
  name = "print_type",
  wrapperProps,
}: RRDDirectPrintTypeInputProps) {
  const [printTypeField, , printTypeHelpers] = useField(name);
  const { setValue } = printTypeHelpers;

  const handlePrintTypeChange = useCallback(
    (newValue) => {
      setValue(newValue);
    },
    [setValue]
  );

  return (
    <div>
      <MUICustomAutocompleteSelect
        options={[PRINT_TYPE.BASIC_POSTCARD, PRINT_TYPE.VALUE]}
        // value={printTypeField.value}
        // onChange={handlePrintTypeChange}
        selectProps={{
          onChange: handlePrintTypeChange,
          value: printTypeField.value,
        }}
        wrapperProps={wrapperProps}
      />
    </div>
  );
}

export default memo(RRDDirectPrintTypeInput);
